import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getSlugByLang, getSlugNameByLang } from '../common/Helper';


const HomeMainBannerSection = ({
    handleKeyUp,
    searchValue,
    setSearchValue,
    onClickReset,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    onClickProduct,
    onClickDestination,
    onClickActivity,
    dropdownRef,
    suggetionHistory,
    setIsSearchFocused,
    isSearchFocused,
    searchKeyRef,
    blogsSuggetion,
    onClickBlog
}) => {

    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)

    return (

        <>

            <section className="mainBanner">
                <div className="bannerBox">
                    <div className="container">
                        <div className="bannerText homepagebanner">
                            <div className="sliderText">
                                <p>Find and book a great experience.</p>
                                <h2>Escape the Ordinary  Dive  into Extraordinary</h2>
                            </div>
                            <div className="typeBox search-group">
                                <input
                                    ref={dropdownRef}
                                    type="search"
                                    className="clickList"
                                    onKeyUp={(e) => handleKeyUp(e)}
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)} // Update state
                                    onFocus={(e) => {
                                        handleKeyUp(e)
                                        e.stopPropagation();
                                        if (suggetionHistory?.length > 0) {
                                            setIsSearchFocused(true);
                                        }
                                    }}
                                    // onFocus={() => { suggetionHistory && suggetionHistory?.length > 0 && setIsSearchFocused(true) }}
                                    // onBlur={() => {   setIsSearchFocused(false)}}
                                    placeholder="Where are you travelling to?"
                                />
                                {/* <div className={`search-key ${(searchValue === "" || searchValue.trim().length < 3) ? "d-none" : ""}`}> */}
                                <div className={`search-key ${(isSearchFocused || searchValue?.trim()?.length >= 3 )? "" : "d-none"}`}
                                    ref={searchKeyRef}
                                >

                                    {
                                        isSearchLoading &&
                                        <div className={"preloader"} style={{ position: "absolute" }}>
                                            <div className="preloader-icon"></div>
                                        </div>
                                    }


                                    {
                                        suggetionHistory &&
                                        suggetionHistory?.length > 0 &&
                                        !isSearchLoading &&
                                        productsSuggetion?.length === 0 &&
                                        blogsSuggetion?.length === 0 &&
                                        activitiesSuggetion?.length === 0 &&
                                        destinationSuggetions?.length === 0 &&
                                        suggetionHistory?.length > 0 &&
                                        // searchValue == null &&
                                        searchValue?.trim()?.length < 3 &&

                                        <>

                                            <ul>
                                                <h6 className="search-title">
                                                    <i className="fa-solid fa-magnifying-glass"></i> Recent searches

                                                </h6>
                                                {
                                                    suggetionHistory.map((his, index) => {
                                                        return (
                                                            <li key={index} className='suggetionRecord'>
                                                                <Link to={his?.url}>
                                                                    {his.label}
                                                                    {
                                                                        his?.sublabel &&
                                                                        <span>{his?.sublabel}</span>
                                                                    }
                                                                </Link>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </>
                                    }


                                    {/* {
                                        searchValue?.trim()?.length >= 3 && productsSuggetion.length === 0 && activitiesSuggetion.length === 0 && destinationSuggetions.length === 0 && blogsSuggetion.length === 0 &&
                                        <ul>
                                            <li>
                                                <span href="javascript:void(0)">{isSearchLoading ? 'Searching...' : 'No results found'}</span>
                                            </li>
                                        </ul>
                                    } */}
                                    {searchValue.trim().length >= 3 && !isSearchLoading &&
                                        productsSuggetion.length === 0 &&
                                        activitiesSuggetion.length === 0 &&
                                        destinationSuggetions.length === 0 &&
                                        blogsSuggetion.length === 0 &&
                                        <ul>
                                            <li>
                                                <span>No results found</span>
                                            </li>
                                        </ul>
                                    }

                                    {isSearchLoading && (
                                        <ul>
                                            <li>
                                                <span>Searching...</span>
                                            </li>
                                        </ul>
                                    )}
                                    {
                                        destinationSuggetions.length > 0 &&
                                        <ul>

                                            <h6 className="search-title"><i className="fa-solid fa-location-dot"></i>Destinations</h6>
                                            {
                                                destinationSuggetions.map((destination, index) => {
                                                    return (
                                                        <li key={index} className='suggetionRecord'>
                                                            <a href="javascript:void(0)" onClick={() => onClickDestination(destination.name, destination?.parent_name, destination?.[slugField])}>{destination.name}
                                                                {
                                                                    destination?.parent_name &&
                                                                    <span>{destination?.parent_name}</span>
                                                                }
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }

                                    <ul>
                                        {
                                            (productsSuggetion.length > 0 || activitiesSuggetion.length) > 0 &&
                                            <h6 className="search-title"><i className="fa-solid fa-bolt"></i>Аctivities</h6>
                                        }

                                        {
                                            activitiesSuggetion.map((activity, index) => {
                                                return (
                                                    <li key={index} className='suggetionRecord'>
                                                        <a href="javascript:void(0)" onClick={() => onClickActivity(activity.id, activity.name, activity?.[slugField])}>{activity.name}
                                                            {/* <span>{activity?.parent_name}</span> */}
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                        {
                                            productsSuggetion.map((product, index) => {
                                                const productLocation = product?.location ? JSON.parse(product.location) : null;
                                                const spacedValues = productLocation ? Object.values(productLocation).join(', ') : '';
                                                return (
                                                    <li key={index} className='suggetionRecord'>
                                                        <a href="javascript:void(0)" onClick={() => onClickProduct(product.title, spacedValues, product?.[slugField])}>{product.title}
                                                            {
                                                                product?.location &&
                                                                <span>{spacedValues}</span>
                                                            }
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }

                                    </ul>

                                    {
                                        blogsSuggetion.length > 0 &&
                                        <ul>

                                            <h6 className="search-title"><i className="fa-solid fa-newspaper"></i>Blogs</h6>
                                            {
                                                blogsSuggetion.map((blog, index) => {
                                                    return (
                                                        <li key={index} className='suggetionRecord'>
                                                            <a href="javascript:void(0)" onClick={() => onClickBlog(blog.name, blog?.[slugField])}>{blog.name}
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    }
                                </div>
                                <div className="sendBtn">
                                    {
                                        (searchValue?.trim()?.length > 0 || isSearchFocused) ?
                                            <button onClick={onClickReset} className="btn btnSend crossBtn"><i className="fa-solid fa-close"></i></button>
                                            :
                                            <button className="btn btnSend"><i className="fa-solid fa-arrow-right"></i></button>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default HomeMainBannerSection;